import { Bookmark, Menu } from "lucide-react";

interface HeaderProps {
  onSave: () => void;
  onQuote: () => void;
}

export function Header({ onSave, onQuote }: HeaderProps) {
  return (
    <header className="site-header">
      <a className="brand" href="/" aria-label="CBCISO forside">
        <span className="brand-mark" aria-hidden="true">
          <span />
        </span>
        <span className="brand-copy">
          <strong>CBCISO</strong>
          <small>RÅT · ENKELT · BEDRE</small>
        </span>
      </a>

      <nav className="main-nav" aria-label="Primær navigation">
        <a href="#huse">Huse</a>
        <a className="active" href="#konfigurator">Konfigurator</a>
        <a href="#priser">Priser</a>
        <a href="#om">Om os</a>
        <a href="#kontakt">Kontakt</a>
      </nav>

      <div className="header-actions">
        <button className="header-save" type="button" onClick={onSave}>
          <Bookmark size={17} />
          <span>Gem</span>
        </button>
        <button className="button button-primary quote-top" type="button" onClick={onQuote}>
          Få et tilbud
        </button>
        <button className="mobile-menu" type="button" aria-label="Åbn menu">
          <Menu size={22} />
        </button>
      </div>
    </header>
  );
}
